import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AnimateFadeDirective } from '@modules/shared/directives/animate-fade.directive';
import { BackButtonDirective } from '@modules/shared/directives/back-button.directive';
import { MenuActionsComponent } from '@modules/shared/menu-actions/menu-actions.component';
import { VideoUploadSyncCenterButtonComponent } from '@modules/video-upload/video-upload-sync-center-button/video-upload-sync-center-button.component';
import { Store } from '@ngrx/store';
import { selectHasLongVideoEnabledClient } from '@shared/store/clients/clients.selectors';
import { TuiButton, TuiDropdown, TuiHintDescribe, TuiHintDirective } from '@taiga-ui/core';
import { HelpActionsService } from 'src/app/services/help-actions.service';
import { PageTitleService } from '../main-layout/page-title.service';
import { SidebarService } from '../sidebar/sidebar.service';

@Component({
  selector: 'pxc-header',
  templateUrl: './header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [HelpActionsService],
  imports: [
    AnimateFadeDirective,
    CommonModule,
    MenuActionsComponent,
    RouterModule,
    TuiButton,
    TuiDropdown,
    TuiHintDirective,
    TuiHintDescribe,
    BackButtonDirective,
    VideoUploadSyncCenterButtonComponent,
  ],
  host: {
    class: 'bg-full-white flex items-center h-12 md:pointer-events-none gap-1 px-1',
  },
})
export class HeaderComponent {
  readonly helpActions = inject(HelpActionsService).getActions();
  private readonly sidebarService = inject(SidebarService);
  private readonly titleService = inject(PageTitleService);
  private readonly store = inject(Store);

  readonly hasLongVideoEnabledClient = this.store.selectSignal(selectHasLongVideoEnabledClient);

  readonly title$ = this.titleService.title$;
  readonly visible$ = this.titleService.visible$;
  readonly backLink$ = this.titleService.backLink$;

  toggleSidebarCollapsed(): void {
    this.sidebarService.collapsed = !this.sidebarService.collapsed;
  }

  showSidebar(): void {
    this.sidebarService.shown = true;
  }

  scrollToTop(): void {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }
}
